export default function getExtensionIcon(ext) {
    switch(ext) {
        case 'mp4': return 'fal fa-file-video'
        break

        case 'pdf': return 'fal fa-file-pdf'
        break

        case 'png':
        case 'jpg':
        case 'gif': return 'fal fa-file-image'
        break

        case 'zip':
        case 'rar':
        case 'gzip':
        case 'tz': return 'fal fa-file-archive'
        break

        case 'xlsx':
        case 'xls': return 'fal fa-file-excel'
        break

        case 'docx':
        case 'doc': return 'fal fa-file-word'
        break

        case 'pptx':
        case 'ppt': return 'fal fa-file-powerpoint'

        default: return 'fal fa-file'
        break
    }
}